import React, { useState, useRef, useEffect } from "react";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";
import ICONS from "../Constants/Icons.tsx";

interface FollowButtonProps {
  isFollowed: boolean;
  onToggleFollow: () => void;
}

const FollowButton: React.FC<FollowButtonProps> = ({
  isFollowed,
  onToggleFollow,
}) => {
  const [tooltipText, setTooltipText] = useState(
    isFollowed ? "Unfollow engagement" : "Follow engagement"
  );
  const [currentFollowedStatus, setCurrentFollowedStatus] =
    useState(isFollowed);
  const Icon = ICONS();
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    setTooltipText(
      currentFollowedStatus ? "Unfollow engagement" : "Follow engagement"
    );
  }, [currentFollowedStatus]);

  const handleClick = async () => {
    const newFollowedStatus = !currentFollowedStatus;
    setCurrentFollowedStatus(newFollowedStatus);
    onToggleFollow();
  };

  return (
    <div className="relative">
      <Button
        ref={buttonRef}
        rounded
        onClick={handleClick}
        className={`p-button-text p-0 w-2rem h-2rem p-1 ${currentFollowedStatus ? "follow-btn fav-btn" : "following-btn fav-btn"
          }`}
        tooltip={tooltipText}
        tooltipOptions={{ position: "top", showDelay: 0 }}
        icon={
          <img
            src={isFollowed ? Icon.FollowIcon : Icon.FollowingIcon}
            alt="Follow Icon"
            className={isFollowed ? "follow-icon" : "following-icon-class"}
            style={{ width: "20px", height: "20px" }}
          />
        }
      />
    </div>
  );
};

export default FollowButton;
